module.exports = __webpack_public_path__ + "static/media/fluent_scan-text-20-regular.37af7fc6.svg";